export default __webpack_public_path__ + "static/media/icon-tab-invoice.1d3fe7be.svg";